// Mirrors backend/src/constants/sportTypes.ts. Values must stay in sync since
// they're validated server-side and existing trainings.TYPE rows use these
// exact strings -- don't rename without a data migration.
export const SPORT_TYPES = ['Run', 'CO', 'Marche nordique', 'Velo', 'Natation', 'Triathlon', 'Autre'] as const;

export const SPORT_TYPE_LABELS: Record<(typeof SPORT_TYPES)[number], string> = {
    Run: 'Run',
    CO: 'CO',
    'Marche nordique': 'Marche nordique',
    Velo: 'Vélo',
    Natation: 'Natation',
    Triathlon: 'Triathlon',
    Autre: 'Autre',
};
